<template>
	<div>
		<label>
			<input
				type="checkbox"
				class="CheckboxInput"
				:value="optionValue"
				:data-filter="filterKey"
				v-model="selectedOptions"
				@click="$emit('areaFilterChange', optionValue)"
			>
			<span>{{ optionName }}</span>
			<span v-if="displayFacets" class="Facet">{{ facet }}</span>
			<slot name="ExpandCollapseToggle"></slot>
		</label>
	</div>
</template>

<script lang="ts" src="./AreaCheckbox.ts"></script>
<style lang="scss" scoped src="../Checkbox.scss"></style>
